import { Icon, IconProps } from "@chakra-ui/react";

export function ShieldCheckIcon(props: IconProps) {
  return (
    <Icon {...props} viewBox="0 0 20 20">
      <path
        d="M10 1.667L3.333 4.167v4.166c0 4.584 2.85 8.871 6.667 9.917 3.817-1.046 6.667-5.333 6.667-9.917V4.167L10 1.667z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10l1.667 1.667L12.5 8.333"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
